import React, { useEffect, useState } from "react";

import Loader from "../../general/Loader";
import { toast } from "../../../utils/helpers";
import { request } from "../../../utils/request";
import { apiRequest } from "../../../hooks/apiRequest";
import Form from "./Form";

const Edit = ({empleadoId, getDescuentos, toggle, descuento, columnas}) => {
    const [state, setState] = useState({
        saving: false,
    });

    const updateDescuento = async event => {
        event.preventDefault();

        setState({
            ...state,
            saving: true
        });

        const data = new FormData(event.target);
        const response = await apiRequest(data, `empleados/${empleadoId}/descuentos/${descuento.id}`);

        if (response.success) {
            getDescuentos();
            toggle();
            toast("Descuento actualizado.");
            document.getElementById("descuentosform").reset();
        }
        if (response.code === 422) {
            setState({ ...state, errors: response.data.message });
        }

        setState({
            ...state,
            saving: false
        });
    };

    return (
        <form
            id='descuentosform'
            method='post'
            onSubmit={updateDescuento}>
            <input type='hidden' name='_method' value='patch' />
            <div className='popup__header'>Editar Descuento Fijo</div>
            <div className='popup__body'>
                <Form descuento={descuento} columnas={columnas} />
            </div>
            <div className='popup__footer'>
                <button
                    type='button'
                    onClick={toggle}
                    className='btn btn-plain'>
                    Cancelar
                </button>
                {state?.saving ? (
                    <Loader type='small' />
                ) : (
                    <button type='submit' className='btn btn-primary'>
                        Actualizar
                    </button>
                )}
            </div>
        </form>
    );
}

export default Edit;
